<div class="chart-wrapper">
  <div class="chart-wrapper-inner">
    <div class="chart-wrapper__top d-flex align-items-start">
      <div class="chart-wrapper__top__left {{ isCustomizeModeEnable ? 'pointer-events-none' : '' }}">
        <div class="d-flex align-items-center">
          <h3>{{ chartConfig.title }}</h3>

          @if (chartConfig.tooltipContent) {
            <app-hint-icon
              class="d-flex"
              [tooltipText]="chartConfig.tooltipContent"
              />
          }
        </div>
        @if (chartConfig.text) {
          <p class="p2">
            {{ chartConfig.text }}
          </p>
        }
      </div>

      @if (isCustomizeModeEnable) {
        <div class="chart-wrapper__top__right d-flex to-right">
          @if (showDeleteButton) {
            <i
              nz-icon
              nzType="delete"
              nzTheme="twotone"
              [nzTwotoneColor]="'#eb2f96'"
              (click)="chartConfig.isVisible = false"
              style="margin-right: 8px;"
              class="cursor-pointer"
            ></i>
          }
          <button
            nz-button
            nzType="primary"
            [disabled]="chartConfig.size === 3"
            (click)="chartConfig.size = chartConfig.size - 3"
            >
            <i nz-icon nzType="minus" nzTheme="outline"></i>
          </button>
          <button
            nz-button
            nzType="primary"
            [disabled]="chartConfig.size === 12"
            (click)="chartConfig.size = chartConfig.size + 3"
            >
            <i nz-icon nzType="plus" nzTheme="outline"></i>
          </button>
        </div>
      }
    </div>

    <div class="chart-content {{ isCustomizeModeEnable ? 'pointer-events-none' : '' }}">
      <ng-content></ng-content>
    </div>
  </div>
</div>
